<template>
    <div>
        <ConfigTemplate />
    </div>
</template>

<script>
import ConfigTemplate from "./configTemplateView.vue";
export default {
    components: {
        ConfigTemplate,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
